import React, {useEffect, useRef, useState} from 'react';
import { getWithAuth } from "../../Network/HttpMethods";
import * as pdfjsLib from 'pdfjs-dist';
import PDFViewerControls from "./PDFViewerControls";
import { GlobalWorkerOptions } from 'pdfjs-dist';

// pdfjs-dist v4+ ships its worker as an ES module; the file in public/ is
// copied from node_modules/pdfjs-dist/build/ and must match the installed
// pdfjs-dist version, or getDocument throws a version-mismatch error.
const worker = new Worker('/pdf.worker.min.mjs', { type: 'module' });

GlobalWorkerOptions.workerPort = worker;

function PDFViewerComponent({ url }) {
    const canvasRef = useRef(null);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [numPages, setNumPages] = useState(1);

    useEffect(() => {
        async function fetchAndRenderPDF() {
            const canvas = canvasRef.current;
            if (!canvas) {
                console.error("Canvas element not found!");
                return;
            }

            const response = await getWithAuth(url);
            const blob = await response.blob();
            const pdfData = await blob.arrayBuffer();

            const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
            setNumPages(pdf.numPages);
            const page = await pdf.getPage(currentPageNumber);

            const viewport = page.getViewport({ scale: 1.5 });
            const context = canvas.getContext('2d');

            canvas.height = viewport.height;
            canvas.width = viewport.width;

            const renderTask = page.render({ canvasContext: context, viewport });
            await renderTask.promise; // ✅ Correct: await the promise!
        }

        fetchAndRenderPDF();
    }, [url, currentPageNumber]);


    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            width: '100%',
        }}>
            <div style={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'auto',
            }}>
                <canvas ref={canvasRef}/>
            </div>
            <PDFViewerControls
                currentPageNumber={currentPageNumber}
                setCurrentPageNumber={setCurrentPageNumber}
                numPages={numPages}/>
        </div>
    );
}

export default PDFViewerComponent;
